import {Button, Select, Space} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {TaskStatusType} from "../../api/Constants";

const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
};
const handleReset = clearFilters => {
    clearFilters();
};

const statusOptions = [
    {value: "Created", label: "Created"},
    {value: "Assigned", label: "Assigned"},
    {value: "In-Progress", label: "In-Progress"},
    {value: "Complete", label: "Complete"}
]

const getBaseColumnSearchProps = (dataIndex, searchInput, setColumnSearch) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
            <Select
                ref={searchInput}
                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={val => {
                    setSelectedKeys(val ? [val] : [])
                    if (setColumnSearch) {
                        setColumnSearch(dataIndex, val)
                    }
                    handleSearch(selectedKeys, confirm, dataIndex)
                }}
                style={{ marginBottom: 8, display: 'block' }}
                options = {statusOptions}
            />
            <Space>
                <Button
                    onClick={() => {
                        clearFilters && handleReset(clearFilters)
                        if (setColumnSearch) {
                            setColumnSearch(dataIndex, [])
                        }
                        confirm();
                    }}
                    size="small"
                    style={{ width: 90 }}
                >
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    Close
                </Button>
            </Space>
        </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
    filterDropdownProps: {
        onOpenChange(open) {
        },
    }
});

export const getStatusColumnSearchProps = (dataIndex, searchInput, setColumnSearch) => ({
    ...getBaseColumnSearchProps(dataIndex, searchInput, setColumnSearch),
    onFilter: (value, record) => {
        return TaskStatusType.Label[record[dataIndex]].toLowerCase().includes(value.toLowerCase());
    },
});